import BlogFortyFourContainer from "./container/BlogFortyFourContainer";
export default BlogFortyFourContainer;
